import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import { AnimatedRoutedDrawer } from 'src/Components/Drawers/AnimatedRoutedDrawer';
import { ExpenseCreationFormWrapper } from 'src/Components/Forms/Expense/ExpenseCreationFormWrapper';
import { useCurrentAssetId } from 'src/Hooks/Shared/useCurrentAssetId';

const CreateExpenseDrawer = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const isIncome = (location.state as { isIncome?: boolean })?.isIncome ?? false;

  const assetId = useCurrentAssetId();

  return (
    <AnimatedRoutedDrawer
      title={
        isIncome
          ? t('expense.createIncome', 'Ajouter un revenu')
          : t('expense.createOperation', 'Ajouter une opération')
      }
      to={`/asset/${assetId}/expenses`}
    >
      {({ onClose }) => (
        <ExpenseCreationFormWrapper
          onCreate={onClose}
          onCancel={onClose}
          defaultIsIncome={isIncome}
        />
      )}
    </AnimatedRoutedDrawer>
  );
};

export default CreateExpenseDrawer;
